module.exports = __webpack_public_path__ + "img/iconview-blue.a89583be.svg";